import React from 'react';
import { color, boxShadow } from '../constants';
import styled from 'styled-components';
import { RaosWrapper } from 'raos';
import { Container } from 'react-bootstrap';

const MainCont = styled.div`
  margin-top: 2rem;
  padding: .5rem;
  border-radius: .5rem;
  box-shadow: ${boxShadow.outset};
`
const Title = styled.h2`
  display: inline-block;
  text-transform: uppercase;
  border-bottom: 5px solid ${color.prim};
  padding: .5rem 0;
`
const Link = styled.a`
  color: ${color.prim};
  font-weight: bold;
  &:visited{
    color: ${color.tri};
  }
`

export default ()=> (
  <Container>
    <RaosWrapper className="animated fadeIn">
      <MainCont id="showcase">
        <Title>showcase</Title>
        <p>The following examples are based on animate.css, RAOS does not include anime.css as dependency or peerDependency. You can review the complete animations that anime.css has on its <Link target="_blank" href="https://daneden.github.io/animate.css/">website</Link>.</p>
      </MainCont>
    </RaosWrapper>
  </Container>
)
